import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import StyledButton from './StyledButton';

export default class LargeLinkedButton extends Component {
    render() {
        return (
            <div style={{ flex: '1' }}>
                {!this.props.disabled || this.props.disabled === 0 ? (
                    <Link to={{
                        pathname: this.props.buttonDestination,
                        state: {
                            func: this.props.func,
                            detailSite: this.props.detailSite,
                            titel: this.props.titel
                        }
                    }}
                    >
                        <StyledButton className={this.props.className}>{this.props.buttonLabel}</StyledButton>
                    </Link>
                ) : <StyledButton disabled={this.props.disabled} className={this.props.className}>{this.props.children ? this.props.children : this.props.buttonLabel}</StyledButton>
                }
            </div>
        )
    }
}
